import { useContext, useEffect, useRef, useState } from "react";
import Services from "../../../../../services/Services";
import { useLanguage } from "../../../../../LanguageProvider";
import { GeneralContext } from "../../../../../GeneralProvider";
import SHEventETicket from "./SHEventETicket";
import io from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

export default function SHEventMyTickets({ event }) {
    const token = localStorage.getItem("token");
    const { userId, setCreateProjectLoading } = useContext(GeneralContext);

    const { getTranslation } = useLanguage();
    const [tickets, setTickets] = useState([]);

    // --- Socket refs/state ---
    const socketRef = useRef(null);
    const roomNameRef = useRef(null);

    const getSoldTicketList = () => {
        setCreateProjectLoading(true);
        if (event && userId) {

            Services.SocialHiveGetEventMyTickets(token, event?.eventID, userId)
                .then((res) => {
                    setCreateProjectLoading(false);
                    const allTickets = res?.data?.result || [];

                    const sortedTickets = allTickets.sort((a, b) => {
                        const createdA = Number(a.createdDateTime);
                        const createdB = Number(b.createdDateTime);
                        return createdB - createdA; // yeniden eskiye
                    });

                    setTickets(sortedTickets);
                })
                .catch((err) => {
                    console.error(err);
                    setCreateProjectLoading(false);
                });
        }
    };

    useEffect(() => {
        getSoldTicketList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [event]);

    // --- SOCKET: ticket-{userId} odasına katıl ve mesajları dinle ---
    useEffect(() => {
        if (!userId) return;

        // Oda ismini hazırla
        roomNameRef.current = `ticket-${userId}`;

        // Socket bağlantısını aç
        socketRef.current = io(SOCKET_URL, {
            reconnection: true,
            reconnectionAttempts: Infinity,
            transports: ["websocket"],
        });

        const socket = socketRef.current;

        const handleIncomingMessage = (payload) => {
            // Sunucunun formatı { room, message } veya direkt message olabilir.
            const msg = payload;
            const content = msg?.content ?? {};

            const statusRaw = content?.status;
            const status = typeof statusRaw === "string" ? statusRaw.toLowerCase() : statusRaw;
            const incomingNo = content?.ticketNo ?? content?.ticketNO ?? content?.ticket_no;
            const incomingID = content?.ticketID ?? content?.ticketId ?? content?.ticket_id;

            // Sadece 'used' durumunda UI’yı güncelle
            if (status === "used" || status === 1 || status === true) {
                setTickets(prev => {
                    let hit = false;
                    const next = prev.map(t => {
                        const matchNo = incomingNo && String(t.ticketNo) === String(incomingNo);
                        const matchId = incomingID && String(t.ticketID) === String(incomingID);
                        if ((matchNo || matchId) && t.isUsed !== "1") {
                            hit = true;
                            return { ...t, isUsed: "1" };
                        }
                        return t;
                    });
                    // Eşleşme yoksa istersen backend’den tazele (opsiyonel):
                    // if (!hit) getSoldTicketList();
                    return next;
                });
            }
        };

        const joinRoom = () => {
            try {
                socket.emit("joinRoom", roomNameRef.current);
            } catch (e) {
                console.error("joinRoom error:", e);
            }
        };

        socket.on("connect", () => {
            joinRoom();
        });

        // Mesaj dinleyicisi
        socket.on("message", handleIncomingMessage);

        // Temizlik
        return () => {
            try {
                socket.off("message", handleIncomingMessage);
                socket.disconnect();
            } catch (_) { }
        };
    }, [userId]);

    return (
        <div className="sh-settings-main">
            <div className="sh-settings-content" style={{ gap: '15px', display: 'flex', flexDirection: 'column' }}>
                {tickets.length > 0 ? (
                    tickets.map((ticket, index) => (
                        <SHEventETicket
                            key={index}
                            coverImage={event?.cover}
                            ticket={ticket}
                            event={event}
                            status={ticket.isUsed}
                        />
                    ))
                ) : (
                    <div style={{ width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                        <p className="add-request-modal-title">{getTranslation("noTicketsYet")}</p>
                    </div>
                )}
            </div>
        </div>
    );
}